
import {
  LOAD_CATEGORY_SUCCESS,
} from '../actions/types'

const initialState = {
  categories: [{
    _id: '59a3dc6f7ef1ee2a8e563b23',
    name: 'ทั้งหมด',
  }],
}

const categories = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: [
          ...state.categories,
          ...action.payload.categories,
        ],
      }
    default:
      return state
  }
}

export default categories




// WEBPACK FOOTER //
// ./src/reducers/categories.js